import React from 'react';

const PaginationEllipsis = () => {
	return (
		<li className="pagination-ellipsis" aria-hidden="true">
			<span>&hellip;</span>
		</li>
	);
};

export default PaginationEllipsis;
